import { DialogBackdrop } from '@headlessui/react';
import { FC } from 'react';
import { PulseLoader } from 'react-spinners';
import { getColors } from '@/tailwind/get-colors';

export const DrawerLoader: FC = () => (
  <div className="absolute top-0 right-0 bottom-0 left-0">
    <DialogBackdrop
      transition
      className="drawer-dialog-backdrop absolute top-0 right-0 bottom-0 left-0 bg-gray-500/25 transition-opacity duration-100 ease-in-out data-closed:opacity-0"
    />

    <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
      <PulseLoader color={getColors().secondary} />
    </div>
  </div>
);
